<template>
	<div>
		<section class="data-cont">
			<h3 class="fx fx-x-between fx-y-center">
					<div class="fx">
						<p>交易数据累计</p>
						<div class="question-cont">
							<i class="icon-question "></i>
							<div class="question-explain">
								<h5>交易金额</h5>
								<p>收银台支付成功且未退款的金额</p>
								<h5>交易笔数</h5>
								<p>收银台支付成功且未退款笔数</p>
								<h5>日期检索</h5>
								<p>年-月-日 00：00:00 --年-月-日 23:59:59</p>
							</div>
						</div>
					</div>
					<div>
						<el-date-picker
						  v-model="stasticDate"
					      type="daterange"
					      align="right"
					      placeholder="选择日期范围(默认全部)"
					      :picker-options="pickerOptions"
					      @change="handleGetCashierStastic">
					    </el-date-picker>
					</div>
				</h3>
			<div class="member-cont">
				<div class="member-data">
					<ul class="fx text-center">
						<li class="fx-fill">
							<strong>{{totalInfo.pay_fee | filterMoney}}<em>元</em></strong>
							<p>交易金额</p>
						</li>
						<li class="fx-fill">
							<strong>{{totalInfo.pay_count}}<em>笔</em></strong>
							<p>交易笔数</p>
						</li>

					</ul>
				</div>
			</div>
		</section>
		<section class="data-cont mould-index">
			<h3 class="fx fx-x-between fx-y-center">
				<div class="fx fx-y-center">
					<div class="fx">
						<p>交易趋势</p>
						<div class="question-cont">
							<i class="icon-question "></i>
							<div class="question-explain">
								<h5>交易金额</h5>
								<p>交易金额趋势图分析</p>
								<h5>交易笔数</h5>
								<p>交易笔数趋势图分析</p>
							</div>
						</div>
					</div>
				</div>
				<z-daybar :on-click="handleGetCashierTrend"></z-daybar>
			</h3>
			<div class="m-t-20" id="dataCube" style="width:auto;height: 400px;"></div>
		</section>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex'
	export default {
		name: 'PayCount',
		components: {},
		data() {
			return {
				columns: ['门店名称', '收入金额（元）', '交易量（笔）'],
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近15天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				stasticDate:[],
				stasticParams: {
					startDate:null,
					endDate:null
				},
				totalInfo:{
					pay_fee:0,
					pay_count:0
				},
				trendChart:null,
				trendOption: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: ['交易金额','交易笔数']
					},
					grid: {
						left: '3%',
						right: '4%',
						//				        bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: []
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						name: '交易金额',
						type: 'line',
						stack: '金额',
						data: []
					},{
							name: '交易笔数',
							type: 'line',
							stack: '数量',
							data: []
					}
					]
				},
			}
		},
		mounted() {
			this.handleGetCashierStastic();
			this.handleGetCashierTrend(7)
			
			this.initEcharts()
			window.onresize = () =>{
				this.trendChart.resize();
			}
		},
		/*
		 * 属性计算
		 */
		computed: {
		},
		/*
		 * 事件处理
		 */
		methods: {
			initEcharts() {
				//初始化图表
				this.trendChart = this.$echartsInit('dataCube', {
					width: 'auto',
					height: 400
				})
				this.trendChart.setOption(this.trendOption);
			},
			//统计数据
			async handleGetCashierStastic() {
				this.stasticParams.startDate = this.stasticDate.length > 0 ? this.stasticDate[0]:''
				this.stasticParams.endDate = this.stasticDate.length > 0 ? this.stasticDate[1]:''
				try{
					const data = await this.getCashierStastic(this.stasticParams)
					this.$log(data)
					this.totalInfo = data
				}catch(e){
					this.$errorMsg(e)
				}
			},
			async handleGetCashierTrend(day){
				const data = await this.getCashierTrend({day})
				const dates = [],
						counts = [],
						totals = []
				data.map((item,index)=>{
					dates.push(item.day)
					counts.push(this.$filterMoney(item.count))
					totals.push(item.total)
				})
				
				this.trendChart.setOption({
					xAxis: {
						data:dates
					},
					series: [{
							data: counts
						},
						{
							data: totals
						}
					]
				})
			},
			...mapActions(['getCashierStastic', 'getCashierTrend']), // 引入action
		}
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.data-cont {
		border-bottom: none;
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.filter-wapper{
			.el-date-editor{
	            display: none;
	        }
		}
	}
</style>


// WEBPACK FOOTER //
// PayCount.vue?1d978ea8